
export const MenuHandler = {
  // admin
  1: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    // {
    //   name: 'Tablero de Control',
    //   icon: 'icon-pie-chart',
    //   path: '/dashboard',
    //   translate: 'sidebar.nav.DASHBOARD'
    // },
    {
      name: "My Dashboard",
      icon: "fas fa-home",
      path: "/Home",
    },
    {
      name: "Tracking",
      icon: "fas fa-map-marker-alt",
      path: "/Tracking",
    },
    {
      name: 'Container Management',
      icon: 'iconn icon-container-slim-poseidon',
      path: '/Container',
    },
    {
      name: "My Reports",
      icon: "fas fa-chart-line",
      path: "/Reports",
    },
    {
      name: "Cost Management",
      icon: "fas fa-wallet",
      path: "/Cost-Management",
    },
    // {
    //   name: "Customer Service",
    //   icon: "fas fa-globe",
    //   path: "",
    //   submenu: [
    //     {
    //       name: "Help Desk",
    //       path: "/Service-Desk"
    //     }
    //   ]
    // },
    {
      name: "Admin",
      icon: "fas fa-users-cog",
      path: "",
      submenu: [
        {
          name: "Users",
          path: "/Admin",
        },
        {
          name: "Alerts",
          path: "/Alerts",
        },
      ],
      translate: "sidebar.nav.DASHBOARD",
    },
    // {
    //   name: 'Servicio al cliente',
    //   icon: 'icon-settings',
    //   path: '/dashboard',
    //   translate: 'sidebar.nav.ADMIN'
    // }
  ],
  2: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    {
      name: "My Dashboard",
      icon: "fas fa-home",
      path: "/Home",
    },
    {
      name: "Tracking",
      icon: "fas fa-map-marker-alt",
      path: "/Tracking",
    },
    {
      name: "My Reports",
      icon: "fas fa-chart-line",
      path: "/Reports",
    },
  ],
  3: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    {
      name: "My Dashboard",
      icon: "fas fa-home",
      path: "/Home",
    },
    {
      name: 'Container Management',
      icon: 'iconn icon-container-slim-poseidon',
      path: '/Container',
    },
    {
      name: "Tracking",
      icon: "fas fa-map-marker-alt",
      path: "/Tracking",
    },
    {
      name: "My Reports",
      icon: "fas fa-chart-line",
      path: "/Reports",
    },
    // {
    //   name: "Customer Service",
    //   icon: "fas fa-globe",
    //   path: "",
    //   submenu: [
    //     {
    //       name: "Help Desk",
    //       path: "/Service-Desk"
    //     }
    //   ]
    // },
  ],
  4: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    {
      name: "My Dashboard",
      icon: "fas fa-home",
      path: "/Home",
    },
    {
      name: "Tracking",
      icon: "fas fa-map-marker-alt",
      path: "/Tracking",
    },
    {
      name: "My Reports",
      icon: "fas fa-chart-line",
      path: "/Reports",
    },
  ],
  5: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    // {
    //   name: 'Tablero de Control',
    //   icon: 'icon-pie-chart',
    //   path: '/dashboard',
    //   translate: 'sidebar.nav.DASHBOARD'
    // },
    {
      name: "My Dashboard",
      icon: "fas fa-home",
      path: "/Home",
    },
    {
      name: "Tracking",
      icon: "fas fa-map-marker-alt",
      path: "/Tracking",
    },
    {
      name: 'Container Management',
      icon: 'iconn icon-container-slim-poseidon',
      path: '/Container',
    },
    {
      name: "My Reports",
      icon: "fas fa-chart-line",
      path: "/Reports",
    },
    {
      name: "Cost Management",
      icon: "fas fa-wallet",
      path: "/Cost-Management",
    },
    // {
    //   name: "Customer Service",
    //   icon: "fas fa-globe",
    //   path: "",
    //   submenu: [
    //     {
    //       name: "Help Desk",
    //       path: "/Service-Desk"
    //     }
    //   ]
    // },
    // {
    //   name: "Admin",
    //   icon: "fas fa-users-cog",
    //   path: "",
    //   submenu: [
    //     {
    //       name: "Users",
    //       path: "/Admin",
    //     },
    //     {
    //       name: "Alerts",
    //       path: "/Alerts",
    //     },
    //   ],
    //   translate: "sidebar.nav.DASHBOARD",
    // },
    // {
    //   name: 'Servicio al cliente',
    //   icon: 'icon-settings',
    //   path: '/dashboard',
    //   translate: 'sidebar.nav.ADMIN'
    // }
  ],
};

export const NameRole = {
  1: 'Administrador',
  2: 'Cliente',
  3: 'RR',
  4: 'Agente'
}